export default __webpack_public_path__ + "static/media/tailwind.5313be12.jpg";